<template lang="html">
  <div class="" :style="{ 'padding-top': offsetHeight + 'px' }">
    <van-nav-bar
      v-if="true"
      :fixed="true"
      title="礼品卡"
      left-text="首页"
      :left-arrow="true"
      @click-left="onClickLeft"
      ref="navBar"
    />
    <van-cell-group title="适用私房课">
      <van-cell>
        <EpisodeCard
          :compact="true"
          :showDescription="false"
          :showRating="false"
          :showPubtime="false"
          :episodeId="giftCard.object_id"
        />
      </van-cell>
    </van-cell-group>
    <van-cell-group title="购买者">
      <van-cell>
        <GiftCardDetail
          :list-mode="false"
          :gift-card-data="giftCard"
        />
      </van-cell>
    </van-cell-group>
    <van-cell-group :title="invitationTitle">
      <van-cell
        v-for="invitation in giftCard.invitations" :key="invitation.id"
        title=""
        is-link
        @click="invitationDetail(invitation.id)"
      >
        <template #default>
          <div
            v-if="invitation.used"
            style="color:#a1a1a1;"
          >
            好友已接受
          </div>
          <div
            v-else
            style="color:#1989fa"
          >
            赠送给好友
          </div>
        </template>
        <template #icon>
          <van-icon
            v-if="invitation.used"
            name="gift-o"
            color="#a1a1a1"
            size="20px"
            style="line-height: inherit;"
          />
          <van-icon
            v-else
            name="gift-o"
            color="#1989fa"
            size="20px"
            style="line-height: inherit;"
          />
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
import store from '../store/index'
import { NavBar } from 'vant'
import { Cell, CellGroup } from 'vant'
import { Notify } from 'vant'
import GiftCardDetail from './gift-card-detail.vue'
import EpisodeCard from './episode-card.vue'
import Vue from 'vue'
Vue.use(NavBar)
Vue.use(Cell).use(CellGroup)
Vue.use(Notify)
export default {
  name: "GiftCardDetailPage",
  components: {
    GiftCardDetail,
    EpisodeCard
  },
  data () {
    return {
      giftCardId: null,
      prevFullPath: '',
      offsetHeight: 0,
      giftCard: {
        available_count: 0,
        object_id: 0,
        note: '',
        quota: 0,
        sender: {
          id: 0,
          wechat_profile: {
            city: '',
            country: '',
            gender: 0,
            headimgurl: '',
            language: '',
            nickname: '',
            province: ''
          }
        },
        invitations: []
      }
    }
  },
  computed: {
    invitationTitle () {
      return `可赠送 (${this.giftCard.available_count}/${this.giftCard.quota})`
    }
  },
  methods: {
    onClickLeft () {
      store.commit("clearPrevFullPath")
      // this.$router.replace({
      //   name: 'EpisodeDetail',
      //   params: {
      //     episodeId: this.giftCard.object_id
      //   }
      // })
      this.$router.replace({
        name: 'ShowDetail',
        params: {
          slug: this.giftCard.show_slug
        }
      })
    },
    invitationDetail (invitationId) {
      window.console.log("进入邀请详情页")
      this.$router.push({
        name: 'InvitationDetail',
        params: {
          invitationId: invitationId
        }
      })
      // window.console.log(invitationId)
      // Notify(
      //   {
      //     type: 'success',
      //     message: location.href
      //   }
      // )
    }
  },
  mounted () {
    let that = this
    that.giftCardId = that.$route.params.giftcardId
    if (that.giftCardId) {
      that.$api.giftcard.detail(that.giftCardId).then(res => {
        window.console.log(res)
        that.giftCard = res.data
      })
    }
    // if (store.state.prevFullPath) {
    //   that.prevFullPath = store.state.prevFullPath
    //   if (store.state.prevFullPath) {
    //     that.$nextTick(function() {
    //       that.offsetHeight = that.$refs.navBar.$el.offsetHeight
    //     })
    //   }
    // }
    that.$nextTick(function() {
      that.offsetHeight = that.$refs.navBar.$el.offsetHeight
    })

    if (store.state.paymentResult.message) {
      let type
      if (store.state.paymentResult.success) {
        type = 'success'
        // this.paySuccess = true
      } else {
        type = 'warning'
      }
      Notify({ type: type, message: store.state.paymentResult.message })
      store.commit('clearPaymentResult')

      // 清理返回信息，否则左上角会出现返回到支付流程的按钮
      store.commit("clearPrevFullPath")
    }
  }
}
</script>

<style lang="css" scoped>
</style>
